import naturalCompare from 'natural-compare';

/** 根据对象属性排序 */
interface AttributeSortParams<T> {
  key: keyof T;
  items: T[];
  reverse?: boolean;
  isNumber?: boolean;
}
export const attributeSort = <T>(params: AttributeSortParams<T>) => {
  const { key, items, reverse, isNumber } = params;

  items.sort((a, b) => {
    const itemA = `${a[key]}`;
    const itemB = `${b[key]}`;

    // 对于明确的数字字段（时间戳、大小），使用数字比较
    if (isNumber) {
      return Number(itemA) - Number(itemB);
    }

    // 对于字符串字段（包括混合内容），使用自然排序
    return naturalCompare(itemA, itemB);
  });

  return reverse ? items.reverse() : items;
};
